import { Col, Row } from "antd";
import { InputStyle } from "./style";
import InputComponent from "../../../components/InputComponent";
import InputNumberComponent from "../../../components/InputNumberComponent";
import { useDocumentContext } from "../../../context/DocumentContext/DocumentContext";


const CategoryDetail = () => {
	const { documentDetail } = useDocumentContext();

	return (
		<>
			<Row gutter={20}>
				<Col span={10}>
					<InputComponent
						title={"Kategori Adı"}
						placeholder=""
						isRequired
						style={InputStyle}
						value={documentDetail?.categoryName}
						isDisabled
					/>
				</Col>
			</Row >
		</>
	);
};

export default CategoryDetail;
